import { render, staticRenderFns } from "./iDetailView.vue?vue&type=template&id=052d40f6&scoped=true&"
import script from "./iDetailView.vue?vue&type=script&lang=js&"
export * from "./iDetailView.vue?vue&type=script&lang=js&"
import style0 from "./iDetailView.vue?vue&type=style&index=0&id=052d40f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d40f6",
  null
  
)

export default component.exports